export const PRIVATE_LANGUAGE_OPTIONS = [
  { key: 'es', label: 'MENU.LANGUAGE.OPTION_ES' },
  { key: 'en', label: 'MENU.LANGUAGE.OPTION_EN' },
] as const;

export type LanguageKey = (typeof PRIVATE_LANGUAGE_OPTIONS)[number]['key'];